<template>
<section>
    <v-container>
        <v-row justify="start">
          <v-toolbar-title
            class="grey--text text--darken-4 font-weight-black my-5 ml-12"
            >
            Stock Balance
          </v-toolbar-title>
          <v-spacer />
          <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
          >
          </v-text-field>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="medications"
          :options.sync="options"
          :server-items-length="totalMedications"
          :loading="loading"
          loading-text="Loading ..... Please wait"
          :footer-props="{
            itemsPerPageOptions: [ 500, 1000, 2000],
            itemsPerPageText: 'Stock Balance per page',
          }"
          update:options
          class="elevation-23"
        >
            <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-dialog v-model="dialog" max-width="500px">

                      <v-card>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.name" label="Medication name" @click="sortBy(header.value)"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.directive" label="Directive"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="editedItem.description" label="Description"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" class="mr-12 mb-5">
                                <label for="quantity-order"> Quantity Order </label><br>
                                <input v-model="editedItem.quantity.order" type="number" name="quantity-order" id="input"/>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" class="ml-12 pl-2 mb-5">
                                 <label for="quantity-receive"> Quantity Receive </label><br>
                                <input v-model="editedItem.quantity.receive" type="number" name="quantity-receive" id="input"/>
                              </v-col>
                              <v-row>
                                  <v-col cols="12" sm="6" md="5">
                                        <v-menu
                                          v-model="editedItem.menu1"
                                          :close-on-content-click="false"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="290px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                              v-model="editedItem.startDate"
                                              label="Start Date"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-datetime-picker
                                            v-model="editedItem.startDate" timePickerFormat="24hr"
                                            dateFormat="dd-MM-yyyy">
                                          </v-datetime-picker>
                                        </v-menu>
                                      </v-col>

                                      <v-col cols="12" sm="6" md="5" class="ml-10">
                                        <v-menu
                                          v-model="editedItem.menu2"
                                          :close-on-content-click="false"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="200px"
                                        >
                                          <template v-slot:activator="{ on }">
                                            <v-text-field
                                              v-model="editedItem.endDate"
                                              label="End Date"
                                              prepend-icon="event"
                                              readonly
                                              v-on="on"
                                            ></v-text-field>
                                          </template>
                                          <v-datetime-picker no-title scrollable
                                            v-model="editedItem.endDate" timePickerFormat="24hr"
                                            dateFormat="dd-MM-yyyy">
                                          </v-datetime-picker>
                                        </v-menu>
                                      </v-col>
                                </v-row>
                                
                                <!-- Schedule Section -->
                                <v-divider class="my-4"></v-divider>
                                <h3 class="mb-3">Medication Schedule</h3>
                                
                                <!-- Schedule Time -->
                                <v-row>
                                  <v-col cols="12" sm="6">
                                    <v-menu
                                      v-model="editedItem.scheduleTimeMenu"
                                      :close-on-content-click="false"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="editedItem.scheduleTime"
                                          label="Administration Time"
                                          prepend-icon="access_time"
                                          readonly
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-time-picker v-model="editedItem.scheduleTime" no-title scrollable
                                        @input="editedItem.scheduleTimeMenu = false"
                                        format="24hr"
                                      >
                                      </v-time-picker>
                                    </v-menu>
                                  </v-col>
                                </v-row>

                                <!-- Days of Week Checkboxes -->
                                <v-row>
                                  <v-col cols="12">
                                    <v-subheader class="px-0">Select days when medication is needed:</v-subheader>
                                    <v-row>
                                      <v-col cols="6" sm="4" md="3" v-for="day in daysOfWeek" :key="day.value">
                                        <v-checkbox
                                          v-model="editedItem.schedule[day.value]"
                                          :label="day.label"
                                          color="primary"
                                          hide-details
                                        ></v-checkbox>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>

                                <!-- File Attachments Section -->
                                <v-divider class="my-4"></v-divider>
                                <h3 class="mb-3">Required Documents</h3>
                                
                                <v-row>
                                  <v-col cols="12" md="4">
                                    <div v-if="editedItem.authorizationFile">
                                      <p class="mb-2">
                                        <v-icon small left color="success">mdi-file-document-check</v-icon>
                                        Authorization Document
                                      </p>
                                      <v-btn
                                        small
                                        color="primary"
                                        @click="downloadFile('authorization')"
                                        class="mr-2"
                                      >
                                        <v-icon left small>download</v-icon>
                                        Download
                                      </v-btn>
                                      <v-btn
                                        small
                                        color="error"
                                        @click="deleteFile('authorization')"
                                      >
                                        <v-icon left small>delete</v-icon>
                                        Delete
                                      </v-btn>
                                    </div>
                                    <div v-else>
                                      <v-file-input
                                        v-model="fileInputs.authorization"
                                        label="Upload Authorization Document"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                                        prepend-icon="mdi-file-upload"
                                        show-size
                                        @change="handleFileUpload('authorization', $event)"
                                        hide-details
                                      ></v-file-input>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <div v-if="editedItem.prnFile">
                                      <p class="mb-2">
                                        <v-icon small left color="success">mdi-file-document-check</v-icon>
                                        PRN Document
                                      </p>
                                      <v-btn
                                        small
                                        color="primary"
                                        @click="downloadFile('prn')"
                                        class="mr-2"
                                      >
                                        <v-icon left small>download</v-icon>
                                        Download
                                      </v-btn>
                                      <v-btn
                                        small
                                        color="error"
                                        @click="deleteFile('prn')"
                                      >
                                        <v-icon left small>delete</v-icon>
                                        Delete
                                      </v-btn>
                                    </div>
                                    <div v-else>
                                      <v-file-input
                                        v-model="fileInputs.prn"
                                        label="Upload PRN Document"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                                        prepend-icon="mdi-file-upload"
                                        show-size
                                        @change="handleFileUpload('prn', $event)"
                                        hide-details
                                      ></v-file-input>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="4">
                                    <div v-if="editedItem.riskAssessmentFile">
                                      <p class="mb-2">
                                        <v-icon small left color="success">mdi-file-document-check</v-icon>
                                        Risk Assessment Document
                                      </p>
                                      <v-btn
                                        small
                                        color="primary"
                                        @click="downloadFile('riskAssessment')"
                                        class="mr-2"
                                      >
                                        <v-icon left small>download</v-icon>
                                        Download
                                      </v-btn>
                                      <v-btn
                                        small
                                        color="error"
                                        @click="deleteFile('riskAssessment')"
                                      >
                                        <v-icon left small>delete</v-icon>
                                        Delete
                                      </v-btn>
                                    </div>
                                    <div v-else>
                                      <v-file-input
                                        v-model="fileInputs.riskAssessment"
                                        label="Upload Risk Assessment Document"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt"
                                        prepend-icon="mdi-file-upload"
                                        show-size
                                        @change="handleFileUpload('riskAssessment', $event)"
                                        hide-details
                                      ></v-file-input>
                                    </div>
                                  </v-col>
                                </v-row>
                            </v-row>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text  @click="close">Cancel</v-btn>
                          <v-btn color="blue darken-1" text  @click="save">Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.documents="{ item }">
                  <div class="d-flex align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :color="item.authorizationFile ? 'success' : 'grey'"
                          small
                          class="mr-1"
                        >
                          {{ item.authorizationFile ? 'mdi-file-document-check' : 'mdi-file-document-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ item.authorizationFile ? 'Authorization uploaded' : 'No authorization' }}</span>
                    </v-tooltip>
                    
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :color="item.prnFile ? 'success' : 'grey'"
                          small
                          class="mr-1"
                        >
                          {{ item.prnFile ? 'mdi-file-document-check' : 'mdi-file-document-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ item.prnFile ? 'PRN uploaded' : 'No PRN' }}</span>
                    </v-tooltip>
                    
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          :color="item.riskAssessmentFile ? 'success' : 'grey'"
                          small
                        >
                          {{ item.riskAssessmentFile ? 'mdi-file-document-check' : 'mdi-file-document-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ item.riskAssessmentFile ? 'Risk Assessment uploaded' : 'No Risk Assessment' }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row justify="space-around">
                      <span class="group pa-2">
                          <v-icon
                            v-if="$can('update')"
                            small
                            class="mr-2"
                            @click="editItem(item)"
                          >
                            edit
                          </v-icon>
                          <v-icon
                            v-if="$can('delete')"
                            small
                            @click="deleteItem(item)"
                          >
                            delete
                          </v-icon>
                            <v-icon v-if="$can('read')" medium @click="detail_medication(item)">info</v-icon>
                      </span>
                  </v-row>
                </template>
        </v-data-table>
    </v-container>
</section>
</template>
<script>
import {  mapActions } from 'vuex'
import medicationApi from '../../services/api/MedicationApi';
import fileUploadApi from '../../services/api/FileUploadApi';
import moment from 'moment';
export default {
    name: 'medication',
    components: {
    },
    data () {
        return {
            dialog: false,
            medications: [],
            totalMedications: 0,
            loading: true,
            options: {},
            search: '',
            residentId:'',
            fileInputs: {
                authorization: null,
                prn: null,
                riskAssessment: null
            },
            daysOfWeek: [
                { value: 'monday', label: 'Monday' },
                { value: 'tuesday', label: 'Tuesday' },
                { value: 'wednesday', label: 'Wednesday' },
                { value: 'thursday', label: 'Thursday' },
                { value: 'friday', label: 'Friday' },
                { value: 'saturday', label: 'Saturday' },
                { value: 'sunday', label: 'Sunday' }
            ],
             headers: [
                { text: 'Medication Name', value: 'name', class: 'success--text font-weight-bold' },
                { text: 'Resident', value: 'resident.fullName',class: 'success--text font-weight-bold' },
                { text: 'Description', value: 'description', sortable: false, class: 'success--text font-weight-bold'  },
                { text: 'Date Received', value: 'receiveTime', class: 'success--text font-weight-bold' },
                { text: 'Quantity Received', value: 'quantity.receive', class: 'success--text font-weight-bold' },
                { text: 'Quantity Remaining', value: 'quantity.remaining', class: 'success--text font-weight-bold' },
                { text: 'Documents', value: 'documents', sortable: false, class: 'success--text font-weight-bold' },
                { text: 'Actions', value: 'action', sortable: false, class: 'success--text font-weight-bold' },
            ],
              editedItem: {
                name: '',
                directive: '',
                description: '',
                quantity: {
                  order: null,
                  receive: null,
                },
                startDate: null,
                endDate: null,
                menu1: false,
                menu2: false,
                scheduleTime: '',
                scheduleTimeMenu: false,
                schedule: {
                  monday: false,
                  tuesday: false,
                  wednesday: false,
                  thursday: false,
                  friday: false,
                  saturday: false,
                  sunday: false
                }
              },
              defaultItem: {
                name: '',
                description: '',
                receiveTime: '',
                quantity: {
                  order: null,
                  receive: null,
                },
              },
        }
    },
    methods: {
        ...mapActions([
            'update_medication',
        ]),
        editItem (item) {
            this.editedItem = Object.assign({}, item)
            this.defaultItem.startDate = item.startDate;
            this.defaultItem.endDate = item.endDate;
            
            // Initialize schedule data if not present
            if (!this.editedItem.schedule) {
                this.editedItem.schedule = {
                    monday: false,
                    tuesday: false,
                    wednesday: false,
                    thursday: false,
                    friday: false,
                    saturday: false,
                    sunday: false
                }
            }
            if (!this.editedItem.scheduleTime) {
                this.editedItem.scheduleTime = ''
            }
            
            this.dialog = true
        },

        deleteItem (item) {
          confirm('Are you sure you want to delete this medication?') && this.delete_medication(item)
          const index = this.medications.indexOf(item)
          this.medications.splice(index, 1)
        },

        close () {
          this.dialog = false
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
          }, 300)
        },

        save () {
            delete this.editedItem.resident;
            delete this.editedItem.createdOn;
            delete this.editedItem.modifiedOn;
            delete this.editedItem.receiveTime;
            delete this.editedItem.quantity.value;
            delete this.editedItem.user;
            if (this.defaultItem.startDate != this.editedItem.startDate){
               this.editedItem.startDate = this.formatDate(this.editedItem.startDate);
            }
            if (this.defaultItem.endDate != this.editedItem.endDate){
              this.editedItem.endDate=this.formatDate(this.editedItem.endDate);
            }
            this.update_medication({...this.editedItem})
          this.close()
        },
        get_registered_medication_list () {
          this.loading = true
          return new Promise((resolve, reject) => {
              const { sortBy, sortDesc, page, itemsPerPage } = this.options
              if (sortDesc&& sortDesc.length && sortDesc[0] == false){
                var orde = 'asc'
              }
              else{
                 orde = 'desc'
              }
              medicationApi.getRegisteredMedication({page: page, count:itemsPerPage, id:this.residentId, q:'', orderBy: sortBy && sortBy[0], order: orde})
                .then(medications => {
                    this.medications = medications.result
                    this.totalMedications = medications.count
                })
                .catch(error => {
                    return reject(error)
                })

              setTimeout(() => {
                this.loading = false
                }, 1000)
          })
        },
        delete_medication(item) {
            medicationApi.deleteRegisteredMedication(item.id)
                .then(medication => {
                    return ("deleted" + medication);
                })
        },
        detail_medication(medication){
          this.$router.push({ name: 'medicationDetail', params: {residentId:medication.resident.id}})
        },
        formatDate(date) {
          return moment(date).format('DD-MM-YYYY HH:mm')
        },
        async downloadFile(fileType) {
            try {
                await fileUploadApi.downloadMedicationFile(this.editedItem.id, fileType);
            } catch (error) {
                console.error('Error downloading file:', error);
                alert('Error downloading file: ' + error.message);
            }
        },
        async deleteFile(fileType) {
            if (confirm('Are you sure you want to delete this file?')) {
                try {
                    await fileUploadApi.deleteMedicationFile(this.editedItem.id, fileType);
                    // Update the edited item to reflect the change
                    this.editedItem[`${fileType}File`] = null;
                    alert('File deleted successfully');
                } catch (error) {
                    console.error('Error deleting file:', error);
                    alert('Error deleting file: ' + error.message);
                }
            }
        },
        async handleFileUpload(fileType, file) {
            if (!file) return;
            
            try {
                await fileUploadApi.uploadMedicationFile(this.editedItem.id, fileType, file);
                // Update the edited item to reflect the change
                this.editedItem[`${fileType}File`] = fileUploadApi.getFileUrl(this.editedItem.id, file.name);
                alert('File uploaded successfully');
                // Clear the file input
                this.fileInputs[fileType] = null;
            } catch (error) {
                console.error('Error uploading file:', error);
                alert('Error uploading file: ' + error.message);
            }
        }
    },
    created() {
        this.residentId = this.$route.params.residentId;
        this.get_registered_medication_list();
    },
    watch: {
        options: {
          handler () {
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          },
          deep: true,
        },
        '$route.params.residentId': {
          handler () {
            this.residentId = this.$route.params.residentId;
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          },
          deep: true,
          immediate: true,
        },
        dialog (val) {
          val || this.close()
        },
        editedItem: function() {
          this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
        },
        search: function() {
          if(this.search.length > 0){
                return new Promise((resolve, reject) => {
                  medicationApi.getRegisteredMedication({page:'', count:'', id:this.residentId, q:this.search})
                    .then(medications => {
                      this.medications = medications.result
                      this.totalMedications = medications.count
                    })
                    .catch(error => {
                      return reject(error)
                    })
                })
          }
          if(this.search.length <= 0){
            this.get_registered_medication_list()
                .then(data => {
                    this.medications = data.result
                    this.totalMedications = data.count
                })
          }
        },
    },
}
</script>
<style lang="scss">
  #input {
    width:70%;
  }
</style>
